import { ComplexRoute } from 'router/components/Routes/Routes';
import SchoolLogoGroupWrapper from 'router/subrouters/Dashboard/components/SchoolLogoGroupWrapper';
import AssociationContactDetails from '../../pages/AssociationContactDetails';
import IndependentCharterSchoolGroup from '../../pages/IndependentCharterSchoolGroup';
import SchoolAssociations from '../../pages/SchoolAssociations';
import SchoolPartOfAssociation from '../../pages/SchoolPartOfAssociation';
import DisctrictSchools from '../District/pages/DisctrictSchools';
import DisctrictSchoolsPreview from '../District/pages/DisctrictSchoolsPreview';

const routes: Readonly<Array<ComplexRoute>> = [
  {
    path: 'schools-preview',
    element: DisctrictSchoolsPreview,
  },
  {
    path: 'schools',
    element: DisctrictSchools,
  },
  {
    path: 'part-of-association',
    element: SchoolPartOfAssociation,
  },
  {
    path: 'school-logo',
    element: SchoolLogoGroupWrapper,
  },
  {
    path: 'choose-associations',
    element: SchoolAssociations,
  },
  {
    path: 'association-contact-details',
    element: AssociationContactDetails,
  },
  {
    index: true,
    element: IndependentCharterSchoolGroup,
  },
] as const;

export default routes;
